import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{ backgroundColor: '#222221' }}
      className="w-full h-14 flex justify-between items-center px-10 absolute bottom-0 border-t border-gray-700"
    >
      <div className="text-sm font-normal text-gray-300">
        © {currentYear} Hashtag Generation. All rights reserved.
      </div>

      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-white">Powered by</span>
        <a
          href="https://debugsire.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-opacity hover:opacity-90"
        >
          <img
            className="h-8 px-2 py-1 object-contain bg-white rounded"
            src="/debugsire.png"
            alt="Debugsire Logo"
          />
        </a>
      </div>
    </footer>
  );
}
